import type { AllowedAny } from '#/types';
import { isClient } from './general';

/**
 * A function that calls a function when the document is ready.
 * @param fn - The function to call when the document is ready.
 */
export function documentReady(fn: (...args: AllowedAny[]) => void) {
  if (!isClient()) {
    return;
  }

  // see if DOM is already available
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    // call on next available tick
    setTimeout(fn, 1);
  } else {
    document.addEventListener('DOMContentLoaded', fn);
  }
}
